import { useHookstate } from "@hookstate/core";
import { GET_RELEASE_QUERY_KEY } from "../api/readerScreenApi";
import { useParams } from "react-router";
import { rootComponentsStore } from "../../../hookstate/rootComponentsStore";
import { useUserEntitlementQueryKey } from "../../../hooks/useUserEntitlementQueryKey";

export function useReleaseDataQueryKey(
  uuidOverride?: string,
  freeOnly = false,
) {
  const params = useParams();
  const uuid = uuidOverride ?? params.uuid;
  const entitlementQueryKey = useUserEntitlementQueryKey();

  // Feed previews and the full reader scope to separate cache entries so a
  // truncated free-only payload doesn't pollute the full reader's cache.
  const scope = freeOnly ? "freeOnly" : "full";

  return [...GET_RELEASE_QUERY_KEY, uuid, scope, ...entitlementQueryKey];
}

export function useReleaseInfoDataQueryKey() {
  const uuid = useHookstate(rootComponentsStore.slideInMenuConfig).get({
    noproxy: true,
  })?.releaseUuid;
  const entitlementQueryKey = useUserEntitlementQueryKey();

  return ["releaseDetailsRelease", uuid, ...entitlementQueryKey];
}
